<template>
    <div>
    <v-dialog v-model="visualizar" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ contacto.nombre }}</span>
          <v-spacer></v-spacer>
         
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="contacto.nombre" label="Nombre" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="contacto.cargo" label="Cargo" required outlined></v-text-field>
              </v-col>              
              <v-col cols="4">
                <v-text-field v-model="contacto.area" label="Area" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="contacto.funcion" label="Funcion" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="contacto.fono" label="Fono" required outlined type="number"></v-text-field>
              </v-col>              
              <v-col cols="4">
                <v-text-field v-model="contacto.celular" label="Celular" required outlined type="number"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="contacto.mail" label="E-Mail" required outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="contacto.direccion" label="Dirección" outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="contacto.observaciones" label="Observaciones" outlined></v-text-field>
              </v-col>
 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import api from "../conf/ruta-base"
import moment from "moment";
import axios from 'axios';
import swal from "sweetalert";
moment.locale('es');
export default {
    data() {
        return {
            contacto:{
                // nombre: null,
                // cargo: null,
                // area: null,
                // funcion: null,
                // fono: null,
                // celular: null,
                // mail: null,
                // direccion: null,
                // observaciones: null,
            },
            contactoDefault: {},
        }
    },
  props: {
    editedItem: {
      type: Object,
      default: null
    },
    editedIndex: {
        type: Number,
        default: -1
    },
    visualizar: {
        type: Boolean,
        default: false,
    }
  },
  watch:{
    editedItem(data){
        if(data) this.contacto = data;
    },
  },
  methods: {
    //Metodo que se trae la informacion de la fecha formato mysql y la retorna local
    momento(fecha){
      return moment(fecha).format('L')
    },
    //empuja el archivo al componente padre
    onFileCharge(){
        this.$emit('cargaArchivos',this.chosenFile)
        this.chosenFile = null
    },
    close(){
        this.$emit('close',false)
    },
    presave(){
        if(!this.contacto.nombre || !this.contacto.cargo || !this.contacto.area || !this.contacto.funcion) {
            swal('','Los campos de identificacion son obligatorios','error'); return;
        }
        if(!this.contacto.fono || !this.contacto.celular || !this.contacto.mail) {
            swal('','Los campos de contacto son obligatorios','error'); return;
        }
        if(!this.contacto.direccion || !this.contacto.observaciones) {
            swal('','Los campos de detalles son obligatorios','error'); return;
        }
        if(this.editedIndex == -1){
            axios.post(`${api.api}contactos`,this.contacto).then(res=>{
                this.$emit('cargaContactos',res.data)
                this.$emit('close',false)
                swal('','Contacto guardado','success');
            }).catch(err=>{
                swal('','Error al guardar contacto','error');
            })
        }else{
            axios.put(`${api.api}contactos/${this.contacto.id}`,this.contacto).then(res=>{
                this.$emit('cargaContactos',this.contacto)
                //this.$emit('close',false)
                swal('','Contacto actualizado','success');
            }).catch(err=>{
                swal('','Error al actualizar contacto','error');
            })
        }
    },
  },
}
</script>